import React, { createContext, useMemo, useState } from "react";
import { Route } from "react-router-dom";
import { ScreenIntereseses } from "./ScreenIntereseses";
// Menú del módulo de Crédito. Para REVERTIR al menú anterior basta con cambiar el component
// del Route "/Credito/Main" (más abajo) por <CreditoMainScreen />: ambas pantallas quedan
// importadas y funcionando, consumen el mismo endpoint y los mismos permisos.
// eslint-disable-next-line no-unused-vars -- se conserva importado para poder revertir el menú
import { CreditoMainScreen } from "./CreditoMainScreen"; // menú anterior (lista de botones)
import CreditoMenuScreen from "./CreditoMenuScreen"; // menú nuevo (tarjetas agrupadas + buscador)
import { ScreenDocumentos } from "./Screens/ScreenDocumentos";
import ListadoTasasScreen from "./InteresesJDF/ListadoTasasScreen";
import ListadoTasasValoresScreen from "./InteresesJDF/ListadoTasasValoresScreen";
import { FacturarEquipoScreen } from "./FacturarEquipo/FacturarEquipoScreen";
import { CargarDatosFacturaScreen } from "./FacturarEquipo/CargarDatosFacturaScreen";
import PagaresListScreen from "./PAgares/PagaresListScreen";
import { PagareSaveChanges } from "./PAgares/PagareSaveChanges";
import { FacturarCreditoCerradoScreen } from "./FacturarCreditoCerrados/FacturarCreditoCerradoScreen";
import { ListadoCreditosCerrados } from "./FacturarCreditoCerrados/ListadoCreditosCerrados";
import { ReporteBuroCredito } from "./BuroCredito/ReporteBurodeCredito";
import { ReporteClientesNoReportado } from "./BuroCredito/ReporteClientesNoReportados";
import { DetalleBuroCredito } from "./BuroCredito/DetalleBurodeCredito";
import { PrestamoClientesMainScreen } from "./PrestamoClientes/PrestamoClientesMainScreen";
import { PrestamoClientesDetalleFinanciamiento } from "./PrestamoClientes/PrestamoClientesDetalleFinanciamiento";
import { ListadoSolicitudesCredito } from "./PanelControlSolicitudes/ListadoSolicitudesCredito";
import { OperacionesNoEncontradasEquipScreen } from "./OperacionesNoEncontradasEquip/OperacionesNoEncontradasEquipScreen";
import { FacturasNoRegistradasEquipScreen } from "./FacturasNoRegistradasEquip/FacturasNoRegistradasEquipScreen";
import { Operacionestasa0 } from "./Operacionestasa0/Operacionestasa0";
import { CumplimientoDocumentacionCondicionadaScreen } from "../Ventas/CumplimientosCompromisoCredito/CumplimientoDocumentacionCondicionadaScreen";
import { ListadoClientesNoRegistradosScreen } from "./ClientesNoRegistrados/ClientesnoRegistradosScreen";
import { ClientesEspecialesScreen } from "./ClientesEspeciales/ClientesEspecialesScreen";
import { FacturasNoContempladasScreen } from "./FacturasNoContempladas/FacturasNoContempladasScreen";
import { ListadoClientesScreen } from "./CarteraClientes/ListadoClientesScreen";
import { DetalleClientesScreen } from "./CarteraClientes/DetalleClientesScreen";
import { DiferenciasVencimientoScreen } from "./DiferenciasVencimiento/DiferenciasVencimientoScreen";

import { ReestructuracionCreditoMainScreen } from "./ReestructuracionCredito/ReestructuracionCreditoMainScreen";
import ReestructurarCreditoCondicionesScreen from "./ReestructuracionCredito/ReestructurarCreditoCondicionesScreen";
import { ListadoClientesEnviadoJuridicoScreen } from "./ClientesJuridico/Screen/ListadoClientesEnviadoJuridicoScreen";
import { DetalleClientesEnviadoJuridicoScreen } from "./ClientesJuridico/Screen/DetalleClientesEnviadoJuridicoScreen";
import { ListadoClientesJuridicoScreen } from "../CreditoyCobranza/CobranzaJuridico/ListadoClientesJuridicoScreen";
import { DetalleClientesGestionarJuridicoScreen } from "./Juridico/Screen/DetalleClientesGestionarJuridicoScreen";
import { RefacturacionListadoScreen } from "./Refacturacion/RefacturacionListadoScreen";
import { RefacturacionCreditoScreen } from "./Refacturacion/RefacturacionCreditoScreen";
import { ListadoClientesGestionarScreen2 } from "../CreditoyCobranza/GestionCobranza/Screen/ListadoClientesGestionarScreen2";
import { RelacionDocumentosSCMain } from "./RelacionDocumentosSC/RelacionDocumentosSCMain";
import CarteraTransitoMainScreen from "../CarteraTransito/CarteraTransitoMainScreen";

export const ListadoCreditoContext = createContext(null);
export const ListadoCredito = () => {
  const [stateAnalisis, setStateAnalisis] = useState({
    folio: "",
    cliente: "",
    filtros: {
      razonSocial: [],
      tipoSolicitud: [],
      lineaCredito: [],
      estado: [],
      sucursal: [],
      vendedor: [],
      folio: [],
    },
  });
  const contextValue = useMemo(
    () => ({
      state: stateAnalisis,
      setState: setStateAnalisis,
    }),
    [stateAnalisis, setStateAnalisis]
  );

  return (
    <ListadoCreditoContext.Provider value={contextValue}>
      <div className="main-container">
        <Route
          path="/Credito/Main"
          // Rollback: <CreditoMainScreen />
          component={() => <CreditoMenuScreen />}
        />
        <Route
          path="/Credito/Intereses"
          component={() => <ScreenIntereseses />}
        />
        <Route
          path="/Credito/Documentos"
          component={() => <ScreenDocumentos />}
        />
        <Route
          path="/Credito/Intereses2"
          component={() => <ListadoTasasScreen />}
        />
        <Route
          path="/Credito/tasavalores"
          component={() => <ListadoTasasValoresScreen />}
        />
        <Route
          path="/Credito/listadoequiposfacturar"
          component={() => <FacturarEquipoScreen />}
        />
        <Route
          path="/Credito/facturarequipo"
          component={() => <CargarDatosFacturaScreen />}
        />

        <Route
          path="/Credito/listadopagares"
          component={() => <PagaresListScreen />}
        />
        <Route
          path="/Credito/pagareSaveChanges"
          component={() => <PagareSaveChanges />}
        />
        <Route
          path="/Credito/ListadoFacturarCreditoOtorgado"
          component={() => <ListadoCreditosCerrados />}
        />
        <Route
          path="/Credito/FacturarCreditoOtorgado"
          component={() => <FacturarCreditoCerradoScreen />}
        />
        <Route
          path="/Credito/ReporteBuroCredito"
          component={() => <ReporteBuroCredito />}
        />
        <Route
          path="/Credito/ClientesNoReportados"
          component={() => <ReporteClientesNoReportado />}
        />
        <Route
          path="/Credito/DetalleBuroCredito"
          component={() => <DetalleBuroCredito />}
        />
        <Route
          path="/Credito/PrestamoClientes"
          component={() => <PrestamoClientesMainScreen />}
        />
        <Route
          path="/Credito/DetalleFinanciamiento"
          component={() => <PrestamoClientesDetalleFinanciamiento />}
        />
        <Route
          path="/Credito/PCSolicitudes"
          component={() => <ListadoSolicitudesCredito />}
        />
        <Route
          path="/Credito/OperacionesNoEncontradasEquip"
          component={() => <OperacionesNoEncontradasEquipScreen />}
        />
        <Route
          path="/Credito/FacturasNoRegistradasEquip"
          component={() => <FacturasNoRegistradasEquipScreen />}
        />
        <Route
          path="/Credito/Operacionestasa0"
          component={() => <Operacionestasa0 />}
        />
        <Route
          path="/Credito/CumplimientoCompromisosCredito"
          component={() => <CumplimientoDocumentacionCondicionadaScreen />}
        />
        <Route
          path="/Credito/ClientesnoRegistrados"
          component={() => <ListadoClientesNoRegistradosScreen />}
        />
        <Route
          path="/Credito/ReestructurarCredito"
          component={() => <ReestructuracionCreditoMainScreen />}
        />
        <Route
          path="/Credito/ReestructurarCreditoCondiciones"
          component={() => <ReestructurarCreditoCondicionesScreen />}
        />
        <Route
          path="/Credito/ClientesEspeciales"
          component={() => <ClientesEspecialesScreen />}
        />
        <Route
          path="/Credito/FacturasnoContempladas"
          component={() => <FacturasNoContempladasScreen />}
        />

        <Route
          path="/Credito/CarteraClientes"
          component={() => <ListadoClientesGestionarScreen2 />}
        // component={() => <ListadoClientesScreen />}
        />


        <Route
          path="/Credito/DetalleCliente"
          component={() => <DetalleClientesScreen />}
        />
        <Route
          path="/Credito/GestionClientesJuridico"
          component={() => <ListadoClientesEnviadoJuridicoScreen />}
        />
        <Route
          path="/Credito/DetalleClientesJuridico"
          component={() => <DetalleClientesEnviadoJuridicoScreen />}
        />
        <Route
          path="/Credito/DiferenciasVencimiento"
          component={() => <DiferenciasVencimientoScreen />}
        />
        <Route
          path="/Credito/CobranzaJuridico"
          component={() => <ListadoClientesJuridicoScreen />}
        />
        <Route
          path="/Credito/DetalleJuridico"
          component={() => <DetalleClientesGestionarJuridicoScreen />}
        />
        <Route
          path="/Credito/ListadoRefacturacion"
          component={() => <RefacturacionListadoScreen />}
        />
        <Route
          path="/Credito/RefacturacionCredito"
          component={() => <RefacturacionCreditoScreen />}
        />
        <Route
          path="/Credito/RelacionDocumentosSC"
          component={() => <RelacionDocumentosSCMain />}
        />
        <Route
          path="/Credito/CarteraTransito"
          component={() => <CarteraTransitoMainScreen />}
        />
      </div>
    </ListadoCreditoContext.Provider>
  );
};
